import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Generates an optimized image URL using Netlify Image CDN.
 * @param {string} url - The local path to the image (e.g., /assets/images/hero.jpg)
 * @param {number} width - The desired width
 * @param {number} quality - The quality (1-100)
 * @returns {string} - The optimized URL
 */
export function getOptimizedImageUrl(url, width, quality = 80) {
  if (!url || url.startsWith('http')) return url;

  // Ensure url starts with a slash
  const cleanUrl = url.startsWith('/') ? url : `/${url}`;

  // In development, return the local path directly so images are visible
  // Netlify Image CDN only works on deployed sites
  if (process.env.NODE_ENV === 'development') {
    return cleanUrl;
  }

  // Netlify Image CDN format
  return `/.netlify/images?url=${encodeURIComponent(cleanUrl)}&w=${width}&q=${quality}`;
}


